module.exports = __webpack_public_path__ + "img/tree-01-b-leaves.bec5a3ff.png";